import React from 'react';
import * as Sentry from '@sentry/react';
import {BrowserTracing} from '@sentry/browser';
import {createRoutesFromChildren, matchRoutes, useLocation, useNavigationType} from 'react-router-dom';
import app from './helpers/app';

const config = app('config');
const integrations = [];
if (config.get('client.sentry.allow-tracing', true)) {
    integrations.push(
        new BrowserTracing({
            routingInstrumentation: Sentry.reactRouterV6Instrumentation(
                React.useEffect,
                useLocation,
                useNavigationType,
                createRoutesFromChildren,
                matchRoutes,
            ),
        })
    );
}

if (config.get('client.sentry.allow-replays', true)) {
    integrations.push(
        new Sentry.Replay({
            maskAllInputs: true,
            unmask: ['.breadcrumbs *'],
        })
    );
}

if (config.get('client.sentry.active', true)) {
    Sentry.init({
        enabled: config.get('client.sentry.active', true),
        dsn: SENTRY_REACT_DSN,
        integrations: integrations,
        tracesSampleRate: +(SENTRY_TRACES_SAMPLE_RATE ?? 0.5),
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1.0,
        environment: APP_ENV ?? 'local',
        release: app('config').get('client.app-version'),
        ignoreErrors: [
            'ResizeObserver loop limit exceeded',// unknown error which only sentry catch
        ],
    });

    app('auth').onUserDetailsChanged((event, {user}) => {
        Sentry.configureScope(scope => {
            scope.setTag('user-role-id', user?.user_role_id);
            scope.setTag('user-role-title', user?.role?.title);
            scope.setUser({
                id: user ? String(user.id) : undefined,
                username: user?.name,
            });

            return scope;
        });
    });
}
